/**
 * Safe wrapper around the Amplitude browser SDK.
 *
 * Amplitude is loaded from a CDN by the snippet in `public/index.html`. Until
 * that script arrives, `window.amplitude` is a queueing stub that defines
 * `init` and `getInstance` but *not* `track` — and if an ad blocker eats the
 * CDN request, it never gains one.
 *
 * That makes optional chaining on the object a trap: `amplitude?.track(...)`
 * still throws "n.track is not a function", which takes down any component
 * that calls it from a mount effect. Check the method, not just the object,
 * and swallow failures — analytics must never break a render.
 */
export const track = (event: string, props?: Record<string, any>): void => {
  try {
    const amplitude = (window as any).amplitude;
    if (typeof amplitude?.track === 'function') {
      amplitude.track(event, props);
    }
  } catch (err) {
    console.warn(`Analytics event "${event}" failed:`, err);
  }
};
